import React from "react";
import { Icon, Button } from "@mui/material";
import { useSlate } from "slate-react";
import { Transforms, Editor, Element as SlateElement } from "slate";

import { classes } from "../../styles";
import { CustomEditor, TextAlignElement } from "../../custom-types";

interface IProps {
  format: string;
  icon: string;
  disabled?: boolean;
}

export const AlignButton: React.FC<IProps> = ({
  format,
  icon,
  disabled = false,
}) => {
  const editor = useSlate();

  const isBlockActive = (editor: CustomEditor, format: string) => {
    const [match] = Editor.nodes(editor, {
      match: (n) =>
        !Editor.isEditor(n) &&
        SlateElement.isElement(n) &&
        n.type === "text-align" &&
        n.align === format,
    });

    return !!match;
  };

  const handleBlockButton = (editor: CustomEditor, format: string) => {
    const isActive = isBlockActive(editor, format);

    if (isActive) {
      Transforms.setNodes(
        editor,
        { type: "paragraph" },
        { match: (n) => Editor.isBlock(editor, n) }
      );
    } else {
      const textAlign: TextAlignElement = {
        type: "text-align",
        align: format,
        children: [],
      };

      Transforms.setNodes(editor, textAlign, {
        match: (n) => Editor.isBlock(editor, n),
      });
    }
  };

  return (
    <Button
      size="small"
      disabled={disabled}
      variant="contained"
      disableElevation={!isBlockActive(editor, format)}
      color={!isBlockActive(editor, format) ? "primary" : "secondary"}
      sx={classes.button}
      onClick={(event) => {
        event.preventDefault();
        handleBlockButton(editor, format);
      }}
    >
      <Icon fontSize="small" sx={classes.icon}>
        {icon}
      </Icon>
    </Button>
  );
};
